/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateCaseNoteTemplateRequest
 */
export interface UpdateCaseNoteTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateCaseNoteTemplateRequest
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateCaseNoteTemplateRequest
     */
    content: string;
}

/**
 * Check if a given object implements the UpdateCaseNoteTemplateRequest interface.
 */
export function instanceOfUpdateCaseNoteTemplateRequest(value: object): value is UpdateCaseNoteTemplateRequest {
    if (!('title' in value) || value['title'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function UpdateCaseNoteTemplateRequestFromJSON(json: any): UpdateCaseNoteTemplateRequest {
    return UpdateCaseNoteTemplateRequestFromJSONTyped(json, false);
}

export function UpdateCaseNoteTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateCaseNoteTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'title': json['title'],
        'content': json['content'],
    };
}

export function UpdateCaseNoteTemplateRequestToJSON(json: any): UpdateCaseNoteTemplateRequest {
    return UpdateCaseNoteTemplateRequestToJSONTyped(json, false);
}

export function UpdateCaseNoteTemplateRequestToJSONTyped(value?: UpdateCaseNoteTemplateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'title': value['title'],
        'content': value['content'],
    };
}

